export function truncateShopifyId(id) {
  return id.split('/').pop()
}